import * as React from 'react';

import { PricingSection, IPricingCardContent } from 'shared/components/PricingSection';

import ChevronRight from 'shared/components/PricingSection/assets/ChevronRight.svg';
import InstantBooking from 'shared/components/PricingSection/assets/InstantBooking.svg';
import { useState } from 'react';
import { setModalFormOpen } from '../../slices';
import { useDispatch } from 'react-redux';
import { Modal } from '@cian/ui-kit';
import { BuyModal, SaleModal } from '../../components/PricingSection/parts';
import { trackCtaClick } from './tracking';

const CARDS: IPricingCardContent[] = [
  {
    labelIcon: InstantBooking,
    labelText: 'Оплата после сделки',
    title: 'Продажа',
    paragraphs: [
      'Обычно риелторы работают за процент от суммы продажи — 1,5–3%.',
      'Процент зависит от сложности сделки: обычная продажа — дешевле. Альтернативные сделки, срочность, нестандартные условия — дороже',
      'Агенты часто дают скидку, если вы пользуетесь их услугами и для продажи жилья, и для покупки нового.',
    ],
    mobileSummary: '1,5–3% от стоимости объекта',
    cardType: 'sale',
  },
  {
    labelIcon: InstantBooking,
    labelText: 'Оплата после сделки',
    title: 'Покупка',
    paragraphs: [
      'За помощь в сопровождении сделки цена обычно фиксированная. В Москве это около 150–200 тыс. рублей, в регионах — ниже.',
      'Если риелтор подбирает для вас объекты, ездит на просмотры, ведёт переговоры и сопровождает сделку, он может попросить предоплату, а комиссия обычно составляет 1,5–2% от стоимости квартиры.',
      'При покупке новостройки риелтор обычно получает вознаграждение напрямую от застройщика, поэтому для вас подбор объекта и сопровождение сделки будут бесплатными.',
    ],
    mobileSummary: <>1,5–2% от&nbsp;стоимости объекта или фиксированная сумма: зависит от&nbsp;объёма услуг</>,
    cardType: 'buy',
  },
];

export const PricingSectionContainer: React.FC = () => {
  const [cardModalOpen, setCardModalOpen] = useState(false);
  const [cardType, setCardType] = useState<'sale' | 'buy'>('sale');

  const Component = cardType === 'sale' ? SaleModal : BuyModal;

  const dispatch = useDispatch();

  const handleCardModalOpen = React.useCallback((cardType: 'sale' | 'buy') => {
    setCardModalOpen(true);
    setCardType(cardType);
  }, []);

  const handleCardModalClose = React.useCallback(() => {
    setCardModalOpen(false);
  }, []);

  const handleModalOpenClick = React.useCallback(() => {
    trackCtaClick();
    dispatch(setModalFormOpen('ticket'));
  }, [dispatch]);

  return (
    <>
      <PricingSection
        cards={CARDS}
        ctaLabel="Подберите мне риелтора"
        chevronIcon={ChevronRight}
        onCardClick={handleCardModalOpen}
        onCtaClick={handleModalOpenClick}
      />

      <Modal open={cardModalOpen} onOpenChange={handleCardModalClose} size="M">
        <Component />
      </Modal>
    </>
  );
};
